export default {"src":"/_next/static/media/pills.a7a15c6a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};